import { Http } from '@/services/http'
import { User } from '@/services/user'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface CascadeLoginParams {
  /** 当前团队token */
  parent_token: string
  /** 当前团队id */
  parent_team_id: string|number
  /** 当前团队接入码 */
  access_code: string
  /** 下级团队ip */
  ip_addr: string
  /** 下级团队ID */
  child_team_id: string|number
  /** 下级团队名称 */
  child_team_name: string
  /** 下级团队端口 */
  server_port: string|number
}

@Injectable()
export class CascadeLoginService {
  constructor (private http: Http, private user: User) {
  }

  cascadeLogin (params: CascadeLoginParams) {
    this.reportLogin({
      parent_team_id: params.parent_team_id,
      access_code: params.access_code,
      child_team_id: params.child_team_id,
      child_team_name: params.child_team_name,
    })
    window.open(
      `${params.ip_addr}:${params.server_port}/cascade-login`
      + `?parent_team_origin=${encodeURIComponent(window.location.origin)}`
      + `&parent_token=${encodeURIComponent(params.parent_token)}`
      + `&parent_team_id=${params.parent_team_id}`
      + `&child_team_id=${params.child_team_id}`
      + `&access_code=${encodeURIComponent(params.access_code)}`
    )
  }

  reportLogin (data: Partial<CascadeLoginParams>) {
    return this.http.post<void>('/cascade/password_free_login_log', data)
  }
}
